import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { AppointmentService } from 'src/app/services/appointment.service';
import { AuthenticationService } from 'src/app/services/authentication.service';

@Component({
  selector: 'app-view-all',
  templateUrl: './view-all.component.html',
  styleUrls: ['./view-all.component.scss']
})
export class ViewAllComponent implements OnInit {
  apptId: any;
  appointmentStatus: any;
  isApptCompleted: boolean=false;

  constructor(private formBuilder: FormBuilder ,private spinner: NgxSpinnerService, private http: HttpClient, private appointmentService: AppointmentService,
    private authenticationService: AuthenticationService, private authService: AuthenticationService, private router: Router) { }

  value: String = "Upcoming";
  appointments: any = []
  userRole: any
  status!: string
  filterForm!: FormGroup;
  tests: any
  surveys: any
  selectedTests: any
  selectedSurveys: any
  disabledButton: boolean = false
  show: boolean = false
  schedules:any
  page=4

  ngOnInit(): void {
    let location = null;
    let diagId = null;
    this.status = "ALL"
    this.show = false;
    jQuery('.modal-backdrop.fade.show').remove();
    this.spinner.show()

    this.userRole = this.authService.getUserType()
    if (this.userRole != 'ADMIN' && this.userRole!='DIRECTOR') {
      diagId = this.authenticationService.getUserId();
    }
    this.appointmentService.getAppointments(location, diagId, this.status, null, null, null).subscribe((res: any) => {
      this.appointments = res.data;

      this.show = true;
      if (this.appointments!=null && this.appointments.length > 0) {
        this.appointments = this.appointments.sort((a: any, b: any) =>(new Date(a.appointmentDetails.schedules[0].appointmentDate)  <= new Date (b.appointmentDetails.schedules[0].appointmentDate) ? -1 : 1));
      }

      this.spinner.hide()

    });

  

    this.filterForm = this.formBuilder.group({
      fromDate: [],
      toDate: [],
    }, { validator: this.dateLessThan('fromDate', 'toDate') });
    
  }

  dateLessThan(from: string, to: string) {
    return (group: FormGroup): {[key: string]: any} => {
      let f = group.controls[from];
      let t = group.controls[to];
      if (f.value && t.value && f.value > t.value) {
        return {
          dates: "To Date should be greater than From Date"
        };
      }
      return {};
    }
  }
  
  submitFilterForm() {
    this.spinner.show()
    this.appointmentService.getAppointments(null,null,"ALL",null, this.filterForm.controls['fromDate'].value, this.filterForm.controls['toDate'].value).subscribe((res: any)=>{
      this.appointments=res.data;
      if (this.appointments.length > 0) {
        this.appointments = this.appointments.sort((a: any, b: any) =>(new Date(a.appointmentDetails.schedules[0].appointmentDate)  <= new Date (b.appointmentDetails.schedules[0].appointmentDate) ? -1 : 1));
      }
      this.show=true
      this.spinner.hide()
    })
  }

  getAppointments() {

  }
  selectValue(value: string) {
    this.value = value;


  }
  setApptId(apptId: any,apptStatus:any) {
    this.isApptCompleted=false

    if(apptStatus=="COMPLETE" || apptStatus=="CANCEL"){
      this.isApptCompleted=true
    }
    
    this.apptId = apptId
    
  }
  getTestTypes() {

  }
  addSurveys() {
    var surveys = this.surveys.surveysList
      .filter((opt: { checked: any; }) => opt.checked)
      .map((opt: any) => opt);
    this.selectedSurveys = surveys;


    var tests = this.surveys.testsList
      .filter((opt: { checked: any; }) => opt.checked)
      .map((opt: any) => opt);
    this.selectedTests = tests;

    let selectedDetails = {
      tests: this.selectedTests,
      surveys: this.selectedSurveys,
      appointmentId: this.apptId
    }
    this.appointmentService.saveSurveyDetails(selectedDetails).subscribe(res => {
      location.reload();
    })


  }
  disableButton() {
  }

 




}